import { useAppSelector } from "../../../../../stateManagement/hooks/redux"

// RoadWorks
export default function RWContent() {

    const mapTooltip = useAppSelector(state => state.mapTooltip)
    const { workState, eventYear, eventTypeString, length, executorOrgName } = mapTooltip ?? {}

    return (
        <>
            <div className="tooltip-info-row">Состояние: {workState}</div>
            <div className="tooltip-info-row">Год: {eventYear}</div>
            <div className="tooltip-info-row">Вид: {eventTypeString}</div>
            <div className="tooltip-info-row">Протяжённость: {length} км</div>
            <div className="tooltip-info-row">Исполнитель: {executorOrgName ?? 'Не известен'}</div>
        </>
    )
}
